import "core-js/modules/es.array.reduce.js";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var eva = /*#__PURE__*/require("eva-icons");

function NbEvaSvgIcon(content) {
  return function (options) {
    return content.toSvg(_extends({
      width: "100%",
      height: "100%",
      fill: "currentColor"
    }, options));
  };
}

var icons = /*#__PURE__*/Object.entries(eva.icons).map(function (_ref) {
  var name = _ref[0],
      icon = _ref[1];
  return [name, NbEvaSvgIcon(icon)];
}).reduce(function (newIcons, _ref2) {
  var name = _ref2[0],
      icon = _ref2[1];
  newIcons[name] = icon;
  return newIcons;
}, {});
export default icons;